export default __webpack_public_path__ + "static/media/shipment-activity-booking.68485f1a.svg";